export const EXIT_REASONS = [
  { value: 'need_different_topic', label: '지금은 다른 주제의 상담이 필요해요' },
  { value: 'got_sufficient_answer', label: '충분히 원하는 답변을 얻었어요' },
  { value: 'not_suitable_situation', label: '상담이 지금 내 상황과는 잘 안 맞는 것 같아요' },
  { value: 'uncomfortable_question', label: '상담사의 질문이 감정적으로 불편했어요' },
  { value: 'overlaps_previous', label: '이전 상담과 겹치는 느낌이에요' },
  { value: 'other', label: '기타' }
]
